import { Button, Select } from "@smart/itops-sb-design-system-dom";
import { useSmokeballApp } from "@smart/itops-smokeball-app-dom";
import { specialChars } from "@smart/itops-utils-basic";

import { dlClassNames } from "./class-names";
import { authApi } from "./local";

const MatterDebugLocal = ({
  accountId,
  userId,
}: {
  accountId: string;
  userId: string;
}) => {
  const { post } = authApi.matter();
  const { result } = authApi.matters({ body: { accountId } });

  return (
    <Select
      label="Matters"
      options={[
        {
          label: "Select a Matter",
          value: "",
          disabled: true,
        },
        ...(result?.map((r) => ({
          label: `${r.number} - ${r.matterTypeName} (${r.isLead ? "Lead" : "Matter"})`,
          value: r.matterId,
        })) || []),
      ]}
      value=""
      onChange={async (matterId) => {
        const context = await post({
          body: { accountId, userId, matterId },
        });
        localStorage.setItem(
          "local-smokeball-app-context",
          JSON.stringify(context),
        );
        window.location.reload();
      }}
    />
  );
};

const MatterDebug = () => {
  const { hostType, matters, context, contacts, layouts } = useSmokeballApp();

  return (
    <>
      {hostType === "local" && context && (
        <MatterDebugLocal accountId={context.firmId} userId={context.userId} />
      )}
      <dl className={dlClassNames}>
        <dt>{matters?.current?.isLead ? "Lead" : "Matter"}</dt>
        <dd>
          {matters?.current?.number || specialChars.enDash} (
          {matters?.current?.status || specialChars.enDash})
        </dd>
        <dt>Id</dt>
        <dd>{matters?.current?.id}</dd>
        <dt>Type</dt>
        <dd>{matters?.current?.matterTypeId || specialChars.enDash}</dd>
      </dl>
      <Button
        text="Log Matter Details"
        onClick={() =>
          console.info({
            context,
            matter: matters?.current,
            contacts: contacts?.current,
            layouts: layouts?.current,
          })
        }
      />
    </>
  );
};

export { MatterDebug };
